import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BrandFormLayer from "../components/BrandFormLayer";

const BrandFormPage = () => {
    return (
        <MasterLayout>
            <BrandFormLayer />
        </MasterLayout>
    );
};

export default BrandFormPage;
